'use client';

import { useEffect } from 'react';
import { identify, setTrackingConsent } from '@upms/observability';
import { useIdentityContext } from '@/components/IdentityContext';

export function ObservabilityUserSync() {
  const { user } = useIdentityContext();

  // Consent is granted only once a user has signed in — never on anonymous
  // page load — and revoked again on sign-out (see AuthProvider's onSignOut in AuthContext).
  useEffect(() => {
    setTrackingConsent(true);
    identify({ email: user.email, id: user.userId });
  }, [user]);

  return null;
}
